import { AuthModel } from '../models/auth/AuthModel';
import appTheme from '../styles/appTheme';
import config from '../config';
import localStorageProvider from '../utils/localStorageProvider';

export default {
  auth: new AuthModel(localStorageProvider.getItem(config.AUTH_STATE_ITEM_NAME)),
  notifications: [],
  consultations: { fetching: true, list: [] },
  unit: null,
  budget: { fetching: true, current: null, saving: false },
  cms: null,
  budgetVoting: { fetching: true, data: null },
  teryt: { fetching: true, localities: [], streets: [] },
  publicSurveyDetails: {
    data: null,
    fetching: false,
  },
  publicSurveyVerification: {
    ok: null,
    fetching: false,
  },
  publicSurveys: {
    data: [],
    fetching: false,
  },
  theme: appTheme,
  account: {
    data: null,
    fetching: false,
  },
  boardThreads: {
    data: [],
    fetching: false,
  },
  boardThreadDetails: {
    data: null,
    fetching: false,
  },
  budgetApplications: {
    data: null,
    fetching: true,
  },
  budgetApplicationDetails: {
    data: null,
    fetching: true,
  },
  budgetAuth: new AuthModel(localStorageProvider.getItem(config.BUDGET_AUTH_STATE_ITEM_NAME)),
  budgetAccount: {
    data: null,
    fetching: false,
  },
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js